import type { BodySide } from "@heraion/shared";

import type { TFn } from "../i18nTypes";
import { joinList } from "../joinList";

/** A pain-map part: a muscle slug, and a side when only one side hurts. */
export type PainPartRef = { slug: string; side?: BodySide };

/** "your chest and your left calf" in the reader's language: each part
 *  named once, in input order. The Logger's today draft (pain veto) and
 *  the read-only pain figure's spoken summary say it the same way. */
export function painPartsPhrase(
  t: TFn,
  parts: ReadonlyArray<PainPartRef>,
  locale: string,
): string {
  const names = parts.map((p) =>
    t(`bodymap.painPart.${p.slug}`, p.side ? { context: p.side } : {}),
  );
  return joinList([...new Set(names)], locale);
}
